import React from "react";
import { Text } from "rebass";
import styled, { withTheme } from "styled-components";

const weights = [100, 200, 300, 400, 500, 600, 700, 800];

const Section = styled.div`
  margin-bottom: 2rem;
`;

const Fonts = props => {
  const variants = weights.map(w => {
    return (
      <div
        style={{
          display: "flex",
          marginBottom: "1rem",
          fontSize: "1rem",
          fontWeight: w
        }}
      >
        <div style={{ marginRight: "20px" }}>{w}</div>
        <div>
          <div>Dolor alias sapiente et veniam error similique qui.</div>
          <div style={{ fontStyle: "italic" }}>
            Dolor alias sapiente et veniam error similique qui.
          </div>
        </div>
      </div>
    );
  });

  const fontSizes = new Array(props.theme.fontSizes.length)
    .fill()
    .map((_, i) => {
      return (
        <div style={{ marginTop: "2rem" }}>
          <div style={{ fontSize: "12px" }}>
            {i} = {props.theme.fontSizes[i]}
          </div>
          <Text style={{ whiteSpace: "nowrap" }} key={i} f={i}>
            Dolor alias sapiente et veniam error similique qui.
          </Text>
        </div>
      );
    });

  const spaces = new Array(props.theme.space.length).fill().map((_, i) => {
    return (
      <div style={{ marginTop: "2rem" }}>
        <div style={{ fontSize: "12px" }}>
          {i} = {props.theme.space[i]}
        </div>
        <div
          style={{
            background: "black",
            width: "100%",
            height: props.theme.space[i]
          }}
        />
      </div>
    );
  });

  return (
    <div>
      <Section>
        <h1>Spaces</h1>
        {spaces}
      </Section>
      <Section>
        <h1>Variants</h1>
        {variants}
      </Section>
      <Section>
        <h1>Sizes</h1>
        {fontSizes}
      </Section>
    </div>
  );
};

export default withTheme(Fonts);



// WEBPACK FOOTER //
// ./src/pages/fonts.js